import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 10],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Audibility test for first order image source S<sub>3</sub>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "12px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/08/principle/audibility-test-7.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
